import React from 'react';
import BlogListGeneric from '../../Generic/BlogListGeneric';

const BlogListEHS = () => {
    return (
      <BlogListGeneric postType="EHS" heading="Environmental Health and Safety" />
  );
};

export default BlogListEHS;